module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_hearts-7.0dd9e912.svg";